module.exports = __webpack_public_path__ + "media/images/banner-41ecb8ba5482a91314742f211d9a380c.png";